module.exports = __webpack_public_path__ + "static/media/Eterno_Thumbnails.39.8d09b84a.png";